import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import "./styles/globals.css";
import "./styles/themes.css";

// ─── Block browser-level pinch-to-zoom on every screen ───────────────────────
// The camera screen implements its OWN pinch-to-zoom via JS (reads e.touches
// and calls handleZoom / camera API) — that logic is unaffected by these guards.

// 1) iOS Safari: gesturestart / gesturechange carry the browser's native
//    pinch-zoom — preventDefault here stops it before it starts.
document.addEventListener("gesturestart",  (e) => e.preventDefault(), { passive: false });
document.addEventListener("gesturechange", (e) => e.preventDefault(), { passive: false });
document.addEventListener("gestureend",    (e) => e.preventDefault(), { passive: false });

// 2) Desktop trackpad / Chrome on Android: wheel + ctrlKey = browser pinch zoom.
document.addEventListener("wheel", (e) => {
  if (e.ctrlKey) e.preventDefault();
}, { passive: false });

// 3) Multi-touch on any screen except camera viewfinder: block browser zoom.
//    Camera viewfinder's own touchmove listener (passive:false on the <video>)
//    calls e.preventDefault() first and drives custom zoom — still works fine.
document.addEventListener("touchmove", (e) => {
  if (e.touches.length > 1) e.preventDefault();
}, { passive: false });
// ─────────────────────────────────────────────────────────────────────────────

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
